(() => {
  const quantity = qs('.js-product-quantity');
  const minus = qs('.js-product-quantity-minus');
  const plus = qs('.js-product-quantity-plus');
  const input = qs('input', quantity);
  
  if(input) {
    if(input.value === input.max) {
      plus.disabled = true;
    }

    if(parseInt(input.value, 10) === 1 || parseInt(input.value, 10) === 0) {
      minus.disabled = true;
      minus.setAttribute('disabled', true);
    }

    plus.addEventListener('click', (e) => {
      e.preventDefault();
      const price = qs('.js-main-product__total-price');
      const singlePrice = qs('.js-main-product__total-price').dataset.singlePrice;

      const priceText = price.innerText;
      const priceReplace = priceText.replace(',', '.');
      const originalPrice = parseFloat(priceReplace);
      const singlePriceReplace = singlePrice.replace(',', '.');
      const singlePriceFloat = parseFloat(singlePriceReplace);

      let totalPrice;

      let inputValue = parseInt(input.value, 10);
      inputValue++;
      if(inputValue <= input.max) {
        input.value = inputValue;

        if(input.value === input.max) {
          plus.disabled = true;
        }

        const addQuantity = (originalPrice + singlePriceFloat).toFixed(2);
        totalPrice = addQuantity;
        price.innerText = addQuantity.replace('.', ',');
      }
      
      if(inputValue > 1) {
        minus.removeAttribute('disabled');
      }
    })
    
    minus.addEventListener('click', (e) => {
      e.preventDefault();
      const price = qs('.js-main-product__total-price');
      const singlePrice = qs('.js-main-product__total-price').dataset.singlePrice;
      
      const priceText = price.innerText;
      const priceReplace = priceText.replace(',', '.');
      const originalPrice = parseFloat(priceReplace);
      const singlePriceReplace = singlePrice.replace(',', '.');
      const singlePriceFloat = parseFloat(singlePriceReplace);

      let totalPrice;

      let inputValue = parseInt(input.value, 10);
      if(inputValue > 1) {
        inputValue--;
        input.value = inputValue;
        plus.removeAttribute('disabled');
        minus.removeAttribute('disabled');
      }

      const minusQuantity = (originalPrice - singlePriceFloat).toFixed(2);
      totalPrice = minusQuantity;
      price.innerText = minusQuantity.replace('.', ',');

      if(inputValue === 1 || inputValue === 0) {
        minus.setAttribute('disabled', true);
      } else {
        minus.removeAttribute('disabled');
      }
    })

    const currentValue = (e) => {
      if(parseInt(e.target.value) <= 0) {
        input.value = 1;
      } else if(parseInt(e.target.value) > input.max) {
        input.value = input.max;
      } else {
        input.value = e.target.value;
        if(input.value === input.max) {
          plus.disabled = true;
        } else {
          plus.removeAttribute('disabled');
        }
      }
    }
    input.addEventListener('change', (e) => currentValue(e));
    input.addEventListener('keyup', (e) => currentValue(e));
    input.addEventListener('paste', (e) => currentValue(e));
  }
})();